"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _index = _interopRequireDefault(require("../icon/index"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _label = _interopRequireWildcard(require("./label"));
var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));
var _dropdownModule = _interopRequireDefault(require("./dropdown.module.scss"));
var _field = require("./field");
var _fieldsize = _interopRequireWildcard(require("./fieldsize"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
// Dropdown
// ========

const Dropdown = props => {
  const renderOptions = () => props.options.map((option, i) => /*#__PURE__*/_react.default.createElement("option", (0, _extends2.default)({
    key: i
  }, option), option.label || option.value));
  const id = props.id || (0, _field.makeIdString)();
  // eslint-disable-next-line no-negated-condition
  const valueProps = props.value !== undefined ? {
    value: props.value
  } : {};
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_dropdownModule.default.Dropdown, props.classNames.wrapper)
  }, /*#__PURE__*/_react.default.createElement(_label.default, {
    className: (0, _classnames.default)(props.classNames.label, {
      [_textfieldModule.default.errorLabel]: props.errorMessage,
      [props.classNames.labelDisabled]: props.disabled
    }),
    for: id,
    tooltip: props.tooltip,
    size: props.size
  }, props.label), /*#__PURE__*/_react.default.createElement(_label.SubLabel, {
    className: (0, _classnames.default)(props.classNames.subLabel, {
      [_textfieldModule.default.errorLabel]: props.errorMessage,
      [_dropdownModule.default.labelDisabled]: props.disabled,
      [props.classNames.labelDisabled]: props.disabled
    }),
    size: props.size
  }, props.subLabel), /*#__PURE__*/_react.default.createElement("span", {
    className: _dropdownModule.default.fieldIconContainer
  }, /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, valueProps, {
    disabled: props.disabled,
    name: props.name,
    id: id,
    "data-test-id": props.dataTestId,
    "aria-label": props.ariaLabel,
    ref: props.innerRef,
    className: (0, _classnames.default)(_dropdownModule.default.field, {
      [_dropdownModule.default.fieldInvalid]: props.errorMessage,
      [_dropdownModule.default.selectDisabled]: props.disabled,
      [props.classNames.selectDisabled]: props.disabled,
      [_dropdownModule.default.fieldSmall]: props.size === _fieldsize.default.SMALL,
      [_dropdownModule.default.fieldDefault]: props.size === _fieldsize.default.DEFAULT
    }, props.classNames.field),
    onChange: props.onChange,
    onFocus: props.onFocus,
    onClick: props.onClick
  }), renderOptions()), /*#__PURE__*/_react.default.createElement(_index.default, {
    type: 'chevron-down',
    size: "small",
    className: _dropdownModule.default.icon,
    role: "presentation"
  })), props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
    message: props.errorMessage,
    className: props.classNames.errorMessage,
    size: props.size
  }));
};
Dropdown.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _field.fieldPropTypes), _fieldsize.fieldSizePropTypes), {}, {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  disabled: _propTypes.default.bool,
  classNames: _propTypes.default.shape({
    wrapper: _propTypes.default.string,
    label: _propTypes.default.string,
    subLabel: _propTypes.default.string,
    field: _propTypes.default.string,
    errorMessage: _propTypes.default.string,
    labelDisabled: _propTypes.default.string,
    selectDisabled: _propTypes.default.string
  }),
  onClick: _propTypes.default.func
});
Dropdown.defaultProps = _objectSpread({
  disabled: false,
  classNames: {}
}, _fieldsize.fieldSizeDefaultProps);
var _default = exports.default = Dropdown;